export const RECOVERY_CODE_PATTERN = /^[A-Z0-9]{4}-[A-Z0-9]{4}$/;

export default function recoveryCodeSanitize(value: string): string {
    const plain = value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 8);
    return plain.length > 4 ? `${plain.slice(0, 4)}-${plain.slice(4)}` : plain;
}
